export default __webpack_public_path__ + "static/media/milkChocolate.d6ecdd3a.jpg";